import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import _ from 'lodash'
import ogImage from "../../images/posts/48/thumb-landscape.jpg"

import Slider from "react-slick";


const Post48 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,

    responsive: [
    {
      breakpoint: 1024,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      }
    },
    {
      breakpoint: 599,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      }
    }
  ]    
  };

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">BALENCIAGA／アワーグラスS／22 x14 x9cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>BALENCIAGA（バレンシアガ）のHOURGLASS（アワーグラス）というバッグをご存知でしょうか？<br></br>2019年の登場から、すぐに人気バッグとなり、BALENCIAGA（バレンシアガ）のアイコン的バッグとなっています。<br></br>今回は、BALENCIAGA（バレンシアガ）の歴史も含めてHOURGLASS（アワーグラス）シリーズをご紹介します。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>1.BALENCIAGA（バレンシアガ）とは？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>2.HOURGLASS（アワーグラス）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>3.HOURGLASS（アワーグラス）のサイズ展開</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>4.HOURGLASS（アワーグラス）のおすすめコーデ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>5.まとめ</ScrollLink>
        </p>
      </div>               
      <div name="sec1" className="text-two-cloumn">
        <h2>1.BALENCIAGA（バレンシアガ）とは？</h2>
        <p>近年ストリートカジュアルのイメージの強いBALENCIAGA（バレンシアガ）ですが、その歴史はとても古く1900年代に設立されたブランドです。<br></br>創立者のCristobal Balenciaga（クリストバル・バレンシアガ）によって、スペインの美食の街・サン・セバスティアンに設立されました。クリストバル・バレンシアガは、女性の服装に革命を起こしたと言われるクリスチャン・ディオールと肩を並べるほどの気鋭のデザイナーであり、モード界で初めてゆったりしたシルエットの服をつくったと言われています。<br></br>2015年に「デムナ・ヴァザリア」（Demna Gvasalia）がクリエイティブ・ディレクターに就任し、ビッグシルエットやSNS映えするようなロゴデザインを送り出し、ストリートとラグジュアリーを融合させ、現在のストリートカジュアルのイメージを牽引しています。
        </p>
      </div>
      <div name="sec2" className="text-two-cloumn">
      <h2>2.HOURGLASS（アワーグラス）とは？</h2>            
      <p>
        創立者Cristobal Balenciaga（クリストバル・バレンシアガ）のシグネチャーであるバスクウエストコート（ウエスト部分のくびれたコート）のシルエットを砂時計【HOURGLASS（アワーグラス）】に見立てたもので、美しくカーブを描いた底部とフラップ部分のBのロゴがポイントのきちんと感も備えたバッグです。
      </p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/48/1.jpg" alt="クラシックなシェイプで人気！BALENCIAGA（バレンシアガ） HOURGLASS（アワーグラス）シリーズ♡"/>
      </figure>
      <span className="text-center">（写真左から：アワーグラスS　アワーグラスXS）</span>      
      <figure>
        <StaticImage src="../../images/posts/48/2.jpg"/>
      </figure>
      <p>こちらはシルバー（真鍮）のBロゴ。<br></br>このほかに、ゴールドや、バッグと同色カラーのものもあります。</p>
      <figure>
        <StaticImage src="../../images/posts/48/3.jpg"/>
      </figure>
      <p>フラップ部分は、マグネット仕様になっており、開閉もスムーズ。（写真はXS　内側ポケットなし）</p>
      <figure>
        <StaticImage src="../../images/posts/48/4.jpg"/>
      </figure>
      <p>トップハンドルと、ショルダーストラップ付きで2wayでの使用が可能です。</p>             
      <Link to="https://laxus.co/app/pc/bags/balenciaga" className="view-all-button">
       BALENCIAGAのバッグを見る
      </Link>              
      <div name="sec3" className="text-max-width">
        <h2>3.HOURGLASS（アワーグラス）のサイズ展開</h2>
        <p>（現在ラクサスで公開しているものを紹介しています）</p>         
      </div>
      <div className="text-max-width">
        <h2>■アワーグラスXS /18x11x7cm(幅x高さxマチ)</h2>
      </div>      
      <Slider className="slide-box" {...settings}>
        <StaticImage src="../../images/posts/48/5.jpg"/>
        <StaticImage src="../../images/posts/48/6.jpg"/>
        <StaticImage src="../../images/posts/48/7.jpg"/>
        <StaticImage src="../../images/posts/48/8.jpg"/>
        <StaticImage src="../../images/posts/48/9.jpg"/>
      </Slider>
      <p>コンパクトなサイズがかわいいXS。</p>            
      <div className="text-max-width">
        <h2>■アワーグラスS /22x14x9cm(幅x高さxマチ)</h2> 
      </div>             
      <Slider className="slide-box" {...settings}>
        <StaticImage src="../../images/posts/48/10.jpg"/>
        <StaticImage src="../../images/posts/48/11.jpg"/>
        <StaticImage src="../../images/posts/48/12.jpg"/>
        <StaticImage src="../../images/posts/48/13.jpg"/>
        <StaticImage src="../../images/posts/48/14.jpg"/>
        <StaticImage src="../../images/posts/48/15.jpg"/>
        <StaticImage src="../../images/posts/48/16.jpg"/>
      </Slider>
      <figure>
        <StaticImage src="../../images/posts/48/17.jpg"/>
      </figure>      
      <p>Sサイズは内側ポケット付きです。</p>
      <div className="text-max-width">
        <h2>■アワーグラス（ミディアム） /27x17x9cm(幅x高さxマチ)</h2> 
      </div>             
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/48/18.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/48/19.jpg"/>
        </figure>        
      </div>
      <p>しっかり収納タイプのミディアムサイズ。</p>
      <div className="text-max-width">
        <h2>■アワーグラスXXS /19x14x7cm(幅x高さxマチ)</h2> 
      </div>             
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/48/20.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/48/21.jpg"/>
        </figure>        
      </div>
      <p>トートタイプのアワーグラス。仕切りはなく、コンパクトでかわいい印象です♡</p>
      <div className="text-max-width">
        <h2>■アワーグラスEWトート /26x17x11cm(幅x高さxマチ)</h2> 
      </div>             
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/48/22.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/48/23.jpg"/>
        </figure>        
      </div>
      <p>センターのジップポケットで2室に分かれたコンパートメント部分には、貴重品の収納も可能。</p>
      <div className="text-max-width">
        <h2>■アワーグラスチェーンショルダー /23x14x5cm(幅x高さxマチ)</h2> 
      </div>             
      <figure className="img-small">
        <StaticImage src="../../images/posts/48/24.jpg"/>
      </figure>
      <p>トップハンドルなしの、チェーンショルダータイプ。アンティークゴールドのBロゴと、チェーンがポイントの少しレトロな雰囲気。</p>
      <div name="sec4" className="text-max-width">
        <h2>4.HOURGLASS（アワーグラス）のおすすめコーデ</h2>
        <figure className="img-small">
          <StaticImage src="../../images/posts/48/25.png"/>
          <span className="text-center">BALENCIAGA／アワーグラスS／22 x14 x9cm</span>
        </figure>
        <span className="text-center">カラーパンツでカジュアルコーデにも◎</span>
        <figure className="img-small">
          <StaticImage src="../../images/posts/48/26.png"/>
          <span className="text-center">BALENCIAGA／アワーグラスEWトート／26 x17 x11cm</span>
        </figure>
        <span className="text-center">ワンピースできちんと感をプラス。</span>
      </div>
      <div name="sec5" className="text-two-cloumn">
        <h2>5.まとめ</h2>
        <p>HOURGLASS （アワーグラス）には豊富なカラー展開があります。<br></br>一度、コーデに取り入れてみてはいかがでしょうか？</p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/balenciaga" className="view-all-button">
       BALENCIAGAのバッグを見る
      </Link>  
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post48

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 48}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
